// extracted by mini-css-extract-plugin
module.exports = {"icons":"o-SCE","icon":"Qca6u","spin":"pA2v6"};